<template>
  <div class="flexContainer" :style="cssProps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: "row",
    },
    horizGap: {
      type: Number,
      default: 0,
    },
    vertGap: {
      type: Number,
      default: 0,
    },
    justifyContent: {
      type: String,
      default: "normal",
    },
    alignItems: {
      type: String,
      default: "normal",
    },
  },

  computed: {
    cssProps() {
      return {
        "--flex-direction": this.direction,
        "--flex-gap": `${this.vertGap}rem ${this.horizGap}rem`,
        "--flex-justify": this.justifyContent,
        "--flex-align": this.alignItems,
      };
    },
  },
};
</script>

<style scoped>
.flexContainer {
  display: flex;
  flex-direction: var(--flex-direction);
  gap: var(--flex-gap);
  justify-content: var(--flex-justify);
  align-items: var(--flex-align);
}
</style>
